import React from 'react';
import logo from '../images/logo.png';
import './Login.css';

export default function SigningInScreen({ title = 'Signing you in…', message = 'Please wait a moment', children }) {
  return (
    <div className="login-page">
      <div className="login-background"><div className="gradient-bg" /><div className="grid-overlay" /></div>
      <div className="login-container">
        <div className="login-box">
          <div className="login-brand">
            <img src={logo} alt="Hermetiq" className="login-logo" />
            <h1 className="login-title">{title}</h1>
            <p className="login-tagline">{message}</p>
          </div>
          {children || (
            <div role="status" aria-label={title} className="login-form" style={{ position: 'relative', minHeight: 24 }}>
              <span className="button-loader" aria-hidden="true" />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
